// LEGACY — superseded by features/clients/. Scheduled for deletion in 2 sprints.
import { APIClient } from "../helpers/api_helper";
import * as url from "../helpers/url_helper";
import { ClientItem } from "../interfaces/Client";
import { ClientsResponse } from "../slices/clients/types";
import { DEFAULT_PAGE_SIZE } from "../common/constants";

const api = new APIClient();

export const getAllClients = (
    pageNumber: number = 1,
    pageSize: number = DEFAULT_PAGE_SIZE
): Promise<ClientsResponse> => {
    // Real API call with query parameters - typed response
    return api.get<ClientsResponse>(url.GET_CLIENTS, {
        pageNumber,
        pageSize,
    });
};

export const createClient = (data: Partial<ClientItem> & { registeredNumber?: string }): Promise<ClientItem> => {
    // Clean payload for backend - remove extra fields
    const payload = {
        tenantId: data.tenantId,
        name: data.name,
        registeredNumber: data.registeredNumber || "",
        gstNumber: data.gstNumber || "",
        address1: data.address1,
        address2: data.address2,
        countryId: data.countryId,
        managerFirstName: data.managerFirstName,
        managerLastName: data.managerLastName,
        managerEmailId: data.managerEmailId,
        phoneNumber: data.phoneNumber || "",
        isPriority: data.isPriority || false,
        priorityReason: data.priorityReason || "",
        logoPath: null,
    };
    return api.create<ClientItem>(url.ADD_NEW_CLIENT, payload);
};

export const updateClient = (
    id: string,
    data: Partial<ClientItem> & { registeredNumber?: string }
): Promise<ClientItem> => {
    // PUT payload must include these fields
    const payload = {
        name: data.name,
        registeredNumber: data.registeredNumber || "",
        gstNumber: data.gstNumber || "",
        address1: data.address1,
        address2: data.address2,
        countryId: data.countryId,
        managerFirstName: data.managerFirstName,
        managerLastName: data.managerLastName,
        managerEmailId: data.managerEmailId,
        phoneNumber: data.phoneNumber || "",
        isPriority: data.isPriority || false,
        priorityReason: data.priorityReason || "",
        logoPath: null,
    };
    return api.put<ClientItem>(url.UPDATE_CLIENT + "/" + id, payload);
};

export const deleteClient = (id: string): Promise<void> => {
    return api.delete<void>(url.DELETE_CLIENT + "/" + id);
};
